import { isApolloError } from '@apollo/client';
import { getGwaEntitlementCookie } from './setCouponCookie';
import { SerializedCartValidationError } from '../types';

/** What web answers with when the email's account has already redeemed the rescue adoption offer. */
export const GWA_PROMO_ALREADY_REDEEMED_CODE = 'gwa_promo_already_redeemed';

export function isGwaPromoAlreadyRedeemed(error: SerializedCartValidationError | null | undefined) {
  return error?.code === GWA_PROMO_ALREADY_REDEEMED_CODE;
}

/**
 * Whether a purchase failed because web turned the adoption promo down for an email that has already
 * used it. The purchase carries the code on the GraphQL error's extensions, where pricing carries it on
 * the cart validation error above.
 */
export function isGwaPromoAlreadyRedeemedPurchaseError(error: unknown) {
  return (
    error instanceof Error &&
    isApolloError(error) &&
    error.graphQLErrors.some((graphQLError) => graphQLError.extensions?.errorCode === GWA_PROMO_ALREADY_REDEEMED_CODE)
  );
}

export interface GwaPromoCheck {
  couponCode: string;
  gwaToken: string;
}

/**
 * What to send with the email check so web can say whether that email has already used the adoption
 * promo. Only a shopper holding the rescue entitlement with a coupon on the cart can be affected, and
 * web answers nothing without both, so everyone else's check stays exactly as it was.
 */
export function gwaPromoForEmailCheck(couponCode: string | undefined): GwaPromoCheck | undefined {
  const gwaToken = getGwaEntitlementCookie();
  return couponCode && gwaToken ? { couponCode, gwaToken } : undefined;
}
